"use strict";

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var fakeCompForDocs = function fakeCompForDocs() {
  return React.createElement('div');
};

var ProgressBar = function ProgressBar(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "control-progress-bar",
    "data-aid": props.automationId,
    "data-hook": props.dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-line-container",
    style: {
      width: props.hideText ? '100%' : 'calc(100% - ' + (_.isNumber(props.progressMax) && props.progressMax > 99 ? 51 : 39) + 'px)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-line",
    style: {
      width: props.progress / (_.isNumber(props.progressMax) ? props.progressMax / 100 : 1) + '%'
    }
  })), !props.hideText && /*#__PURE__*/React.createElement("div", {
    "data-hook": 'progress-text',
    className: "progress-text"
  }, props.progress, _.isNumber(props.progressMax) ? '/' + props.progressMax : '%'));
};

ProgressBar.displayName = displayNames.PROGRESS_BAR;
var propTypes = {
  /** Set the progress */
  progress: PropTypes.number.isRequired,

  /** Override the max progress with a numeric progress, default is 100% */
  progressMax: PropTypes.number,

  /** Hide the progress text */
  hideText: PropTypes.bool,

  /** Unique string used for testing */
  dataHook: PropTypes.string
};
ProgressBar.propTypes = propTypes;
fakeCompForDocs.propTypes = propTypes;
module.exports = compose(ProgressBar);